export enum ProvisioningState {
    Succeeded = 'Succeeded',
    Failed = 'Failed',
    Updating = 'Updating',
    Deleting = 'Deleting',
    Creating = 'Creating',
    Provisioning = 'Provisioning'
}

export enum ConnectionState {
    Pending = 'Pending',
    Approved = 'Approved',
    Rejected = 'Rejected',
    Disconnected = 'Disconnected'
}

export type PrivateEndpointType = 'blob' | 'sqlServer' | 'dfs' | 'sql' | 'account'
    | 'sqlOnDemand' | 'dev' | 'vault' | 'Sql' | 'MongoDB' | 'table' | 'file' | 'postgresqlServer' | 'coordinator'
    | 'mysqlServer' | 'searchService' | 'mariadbServer' | '' | 'managedInstance' | 'amlworkspace' | 'appGatewayFrontendIp'
    | 'Analytical' | 'queue' | 'namespace' | 'azuremonitor' | 'cluster' | 'sites' | 'databricks_ui_api';

export interface IManagedResourcesInfo {
    groupId: PrivateEndpointType;
    resourceId: string;
    linkedServiceType: string;
    sectionHeaderName?: string;
    groupIdDisplayName?: string;
    isManagedResourcePE?: boolean;
    managedByResourceId?: string;
}
